import { render } from "./UploadPoster.vue?vue&type=template&id=e0621c20"
import script from "./UploadPoster.vue?vue&type=script&lang=js"
export * from "./UploadPoster.vue?vue&type=script&lang=js"

import "./UploadPoster.vue?vue&type=style&index=0&id=e0621c20&lang=css"
script.render = render

export default script